export const commentsData: Record<string, { id: string; author: string; content: string; time: string; likes: number }[]> = {
  "1": [
    { id: "c1-1", author: "夜猫子小明", content: "延时摄影太震撼了，尤其是灯光亮起来那一段，鸡皮疙瘩都起来了！", time: "2小时前", likes: 128 },
    { id: "c1-2", author: "摄影爱好者", content: "请问是用什么设备拍的？三脚架稳住真的很重要。", time: "5小时前", likes: 46 },
    { id: "c1-3", author: "路人甲", content: "每天通勤的这座城市，看完才发现原来这么美。", time: "昨天", likes: 89 },
  ],
  "7": [
    { id: "c7-1", author: "笑到肚子疼", content: "室友说要做卷腹，结果第一组就开始躺平，太真实了哈哈哈。", time: "1小时前", likes: 302 },
    { id: "c7-2", author: "健身教练老王", content: "作为教练，看完只想说：动作可以再标准一点。", time: "6小时前", likes: 77 },
  ],
  "13": [
    { id: "c13-1", author: "想去露营", content: "看完立刻开始查周末的露营地，这种治愈感真的太需要了。", time: "3小时前", likes: 154 },
    { id: "c13-2", author: "山野爱好者", content: "清晨的雾气拍得太好了，氛围感拉满。", time: "昨天", likes: 62 },
  ],
  "4": [
    { id: "c4-1", author: "爱看风景", content: "第十个日落的颜色绝了，收藏起来慢慢看。", time: "4小时前", likes: 210 },
  ],
};